namespace advisorop.services {
    `use strict`;

    export class AdvisorHhrService {
        static $inject = [`$http`];
        constructor(private $http: ng.IHttpService) {
        }

        getHhrAccounts(householdId: number, original: boolean = false, groupByProposedRTG: boolean = false): ng.IHttpPromise<domains.IHhrMain> {
            return this.$http.get(`/api/advisor/hhraccounts/${householdId}/${original}/${groupByProposedRTG}`);
        };

        saveHhrAccounts(hhr: domains.IHhrMain): ng.IHttpPromise<domains.IHhrMain> {
            return this.$http.post(`/api/advisor/hhraccounts/save`, hhr);
        };

        commitHhrAccounts(hhr: domains.IHhrMain): ng.IHttpPromise<domains.IHhrMain> {
            return this.$http.post(`/api/advisor/hhraccounts/commit`, hhr);
        };
    }
    angular.module(Constants.ADVOP_SERVICES).service(`advisorHhrService`, AdvisorHhrService);
}